// Formularios públicos (contacto, financiamiento, compra directa, consignación, buscamos por ti, modales de datos/éxito) y correos de leads — English (US). Mismas claves que es/formsUi.ts.
//
// Las claves marcadas "solo BR" se muestran únicamente en sitios de Brasil
// (isBrasil(country)); acá están por paridad de claves.
export const formsUiEn = {
  // alert() de los formularios (FinancingForm, BuyDirectForm, ConsignmentsForm, WeSearchForm)
  errors: {
    noClient:
      "❌ Error: We couldn't identify the dealership. Please reload the page.",
    generic:
      'There was an error submitting your request. Please try again.',
    emailNotSent:
      "We couldn't send the email notification, but your request was received. We'll be in touch soon.",
    duplicate:
      'A request with this information already exists. Please check your details.',
    invalidEmail:
      'There was a problem with the email. Please make sure the email address is valid.',
    customer:
      'There was an error saving your information. Please check your personal details.',
    lead: 'There was an error creating your request. Please check the vehicle details.',
    technicalDetails: 'Technical details',
    requiredFields:
      '❌ Please fill in all required fields (First name, Last name, Email, Phone).',
    brandAndModel: '❌ Please select a vehicle make and model.',
    // Va seguido del nombre del campo (texto del builder), concatenado.
    requiredField: '❌ Please fill in the required field: ',
  },
  // SuccessModal (defaults y mensajes por tipo de lead)
  success: {
    title: 'Your request was sent successfully!',
    message:
      "We've received your request. We'll get in touch with you as soon as possible.",
    button: 'OK',
    consignment:
      "We've received your consignment request. We'll get in touch with you as soon as possible to evaluate your vehicle.",
    buyDirect:
      "We've received your request to sell your car. A sales advisor will contact you with an offer for your vehicle.",
    financing:
      "We've received your financing request. A finance specialist will contact you to go over the available options.",
    contact:
      "We've received your message. We'll get in touch with you as soon as possible.",
    search:
      "We've received your search request. We'll contact you when we find vehicles that match what you're looking for.",
  },
  buyDirect: {
    successAppraisal:
      "We've received your vehicle details. In a few minutes you'll get an estimated purchase price by email, and a sales advisor will contact you to schedule an in-person appraisal.",
    // solo BR: placa brasileña (Mercosul ABC1D23 o vieja ABC1234)
    platePlaceholderBr: 'e.g. ABC1D23',
    plateInvalidBr: 'Check the plate: format ABC1D23 or ABC1234.',
  },
  weSearch: {
    // solo BR: etiqueta del campo dinámico tipo "rut" cuando el builder no le puso nombre
    cpfLabelBr: 'CPF',
  },
  // ContactForm
  contact: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    reason: 'Reason for contacting us',
    // Solo la ETIQUETA: el valor guardado (key del Select) sigue en español.
    reasons: {
      buy: 'Buying a vehicle',
      sell: 'Selling a vehicle',
      general: 'General question',
      other: 'Other',
    },
    message: 'Message',
    submit: 'Send message',
    infoTitle: 'Contact information',
    location: 'Location',
    hours: 'Hours',
    directContact: 'Get in touch',
    emailsLabel: 'Emails',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
  },
  // ContactClient (página /contact sin builder)
  contactPage: {
    title: 'Contact us',
    subtitle:
      "We're here to help. Send us a message and we'll get back to you as soon as possible.",
  },
  // CustomerDataModal
  customerModal: {
    title: 'Save your favorite vehicles!',
    description:
      "We'll let you know when we find similar vehicles at a great price.",
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    cancel: 'Cancel',
    saving: 'Saving...',
    save: 'Save',
  },
};
